import { render } from "./BaseVideoElement.vue?vue&type=template&id=2db5f537&scoped=true&ts=true"
import script from "./BaseVideoElement.vue?vue&type=script&lang=ts"
export * from "./BaseVideoElement.vue?vue&type=script&lang=ts"

import "./BaseVideoElement.vue?vue&type=style&index=0&id=2db5f537&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db5f537"]])

export default __exports__